import { Button, Stack } from "@mui/material";

import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import localisations from "../../../../localisation";

interface IProps {
    addChildMode: boolean;
    enterEditMode: boolean;
    allowDelete: boolean;
    onEditClicked: () => void;
    onCancelChangesClicked: () => void;
    onSaveChangesClicked: () => Promise<void>;
    onAddChildClicked: () => void;
    onDeleteClicked: () => void;
    onSaveChildClicked: () => void;
    isSavingChanges?: boolean;
    isDeleting?: boolean;
    isSavingChild?: boolean;
}

const EditNodeButtons = (props: IProps) => {
    const { enterEditMode: inEditMode, allowDelete, addChildMode, isSavingChanges, isSavingChild } = props;

    const {
        onEditClicked,
        onCancelChangesClicked,
        onSaveChangesClicked,
        onDeleteClicked,
        onAddChildClicked,
        onSaveChildClicked,
    } = props;

    const {
        editDetailsButtonText,
        addChildNodeButtonText,
        cancelChangesButtonText,
        deleteButtonText,
        saveChangesButtonText,
        saveChildButtonText,
    } = localisations.nodeDetails.buttons;

    return (
        <Stack direction="row" spacing={2}>
            {!inEditMode && !addChildMode && (
                <Button aria-label={editDetailsButtonText} onClick={onEditClicked} variant="contained">
                    {editDetailsButtonText}
                </Button>
            )}
            {(inEditMode || addChildMode) && (
                <Button aria-label={cancelChangesButtonText} onClick={onCancelChangesClicked} variant="contained">
                    {cancelChangesButtonText}
                </Button>
            )}
            {inEditMode && !addChildMode && (
                <LoadingButton
                    aria-label={saveChangesButtonText}
                    onClick={onSaveChangesClicked}
                    color="success"
                    variant="outlined"
                    loading={isSavingChanges}
                    startIcon={<SaveIcon />}
                    loadingPosition="start"
                >
                    {saveChangesButtonText}
                </LoadingButton>
            )}
            {!inEditMode && addChildMode && (
                <LoadingButton
                    aria-label={saveChildButtonText}
                    onClick={onSaveChildClicked}
                    color="success"
                    variant="outlined"
                    loading={isSavingChild}
                    startIcon={<SaveIcon />}
                    loadingPosition="start"
                >
                    {saveChildButtonText}
                </LoadingButton>
            )}
            {!inEditMode && !addChildMode && (
                <Button aria-label={addChildNodeButtonText} onClick={onAddChildClicked} variant="contained">
                    {addChildNodeButtonText}
                </Button>
            )}
            {allowDelete && !inEditMode && !addChildMode && (
                <Button aria-label={deleteButtonText} onClick={onDeleteClicked} variant="contained" color="error">
                    {deleteButtonText}
                </Button>
            )}
        </Stack>
    );
};

export default EditNodeButtons;
